import React from 'react';

// Set while the screenshot renderer captures a wallboard slide
// (screens/PrintWallboardShow). Components that can't be captured as a still
// (video) render a placeholder instead, which the TV player overlays live.
export const WallboardPrintContext = React.createContext<{
  isWallboardPrint: boolean;
}>({
  isWallboardPrint: false,
});

const WallboardPrintProvider = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}) => (
  <WallboardPrintContext.Provider value={{ isWallboardPrint: true }}>
    {children}
  </WallboardPrintContext.Provider>
);

export default WallboardPrintProvider;
